import $ from 'jquery';

$(function () {
    $(document).on("click", ".tabs__item-link", function () {
        const class_content = $(this).parents('.tabs').attr('data-class-content');

        $(this).parents('.tabs').find('.tabs__item').removeClass('tabs__item--active');
        $(this).parent().addClass('tabs__item--active');

        $('.' + class_content).addClass(class_content + '--hidden');
        $('#' + $(this).attr('data-id')).removeClass(class_content + '--hidden');
    });
});
